import styled from "@emotion/styled";

import { MDSIcon, MDSIconKind } from "@/mds";

export const AgentTaskStateIcon = ({
  completed,
  size = 16,
}: {
  completed: boolean;
  size?: number;
}) => {
  const iconKind = completed ? MDSIconKind.CheckCircleSolid : MDSIconKind.Circle;

  return (
    <StyledWrapper $completed={completed}>
      <MDSIcon kind={iconKind} size={size} />
    </StyledWrapper>
  );
};

const StyledWrapper = styled.span<{ $completed: boolean }>`
  color: ${({ $completed, theme }) =>
    $completed ? theme.colors.text.positive : theme.colors.text.tertiary};
  display: inline-flex;
  flex: 0 0 auto;
`;
